var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import SelectTemplate from "./SelectTemplate.vue";
import CreateInstance from "@/components/ConfigTemplates/CreateInstance.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateUserObjectStore',
    setup(__props) {
        const loadingTemplatesInfoMessage = "Loading storage location templates";
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.ensureTemplates();
        const templates = computed(() => objectStoreTemplatesStore.latestTemplates);
        const loading = computed(() => objectStoreTemplatesStore.loading);
        const router = useRouter();
        function chooseTemplate(selectTemplateId) {
            return __awaiter(this, void 0, void 0, function* () {
                router.push({
                    path: `/object_store_templates/${selectTemplateId}/new`,
                });
            });
        }
        return { __sfc: true, loadingTemplatesInfoMessage, objectStoreTemplatesStore, templates, loading, router, chooseTemplate, SelectTemplate, CreateInstance };
    }
});
